export type CalendarEventToDelete = {
  id: number;
  name: string;
};

export type CalendarEventsState = {
  calendarEventToDelete: CalendarEventToDelete | null;
  copyEventById: number | null;
  showCreateCalendarEventStepper: boolean;
  successDialogCalendarEventId: number | null;
};

export type CalendarEventsEvent =
  | { type: 'calendarEvents.closeCreateCalendarEventStepper' }
  | { type: 'calendarEvents.closeCreateCalendarEventSuccessDialog' }
  | { type: 'calendarEvents.closeDeleteEventDialog' }
  | { type: 'calendarEvents.openCreateCalendarEventStepper' }
  | { calendarEventId: number, type: 'calendarEvents.openCreateCalendarEventStepperToCopy' }
  | { calendarEventId: number, type: 'calendarEvents.openCreateCalendarEventSuccessDialog' }
  | { calendarEventId: number, calendarEventName: string, type: 'calendarEvents.openDeleteEventDialog' };

export const calendarEventsInitialState: CalendarEventsState = {
  calendarEventToDelete: null,
  copyEventById: null,
  showCreateCalendarEventStepper: false,
  successDialogCalendarEventId: null,
};

export const calendarEventsReducer = (
  prevState: CalendarEventsState = calendarEventsInitialState,
  event: CalendarEventsEvent,
): CalendarEventsState => {
  switch (event.type) {
    case 'calendarEvents.closeCreateCalendarEventStepper':
      return {
        ...prevState,
        copyEventById: null,
        showCreateCalendarEventStepper: false,
      };
    case 'calendarEvents.closeCreateCalendarEventSuccessDialog':
      return {
        ...prevState,
        successDialogCalendarEventId: null,
      };
    case 'calendarEvents.closeDeleteEventDialog':
      return {
        ...prevState,
        calendarEventToDelete: null,
      };
    case 'calendarEvents.openCreateCalendarEventStepper':
      return {
        ...prevState,
        showCreateCalendarEventStepper: true,
      };
    case 'calendarEvents.openCreateCalendarEventStepperToCopy':
      return {
        ...prevState,
        copyEventById: event.calendarEventId,
        showCreateCalendarEventStepper: true,
      };
    case 'calendarEvents.openCreateCalendarEventSuccessDialog':
      return {
        ...prevState,
        successDialogCalendarEventId: event.calendarEventId,
      };
    case 'calendarEvents.openDeleteEventDialog':
      return {
        ...prevState,
        calendarEventToDelete: { id: event.calendarEventId, name: event.calendarEventName },
      };
    default:
      return prevState;
  }
};
